module.exports = __webpack_public_path__ + "static/assets/87f635ef624114368d5c5489d8472821.png";